import type { FC } from "react";
import { useEffect } from "react";
import ObservationBundleBloc from "src/state/ObservationBundleBloc/ObservationBundleBloc";
import { useBlocNext } from "@blac/react";
import DataHub from "src/ui/components/DataHub/DataHub";
import LabResultGroupTable from "src/ui/components/LabResultGroupTable";

const UserLabResults: FC = () => {
  const [{ observationBundles }, { loadObservationBundles }] = useBlocNext(
    ObservationBundleBloc
  );

  const observationBundlesLimited = observationBundles?.slice(0, 20);

  useEffect(() => {
    void loadObservationBundles();
  }, []);

  return (
    <>
      {/* Data Hub */}
      <DataHub />

      <nine-spacer s="lg" />
      <nine-spacer s="xs" />

      {/* List lab results */}
      <LabResultGroupTable observationBundles={observationBundlesLimited} />
    </>
  );
};

export default UserLabResults;
